import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Project from '../views/Project.vue'
import WorkMessageApproval from '../views/WorkMessageApproval.vue'
import WorkMessageReport from '../views/WorkMessageReport.vue'
import Calendar from '../views/Calendar.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
  ,
  {
    path: '/project',
    name: 'project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Project
  },
  {
    path: '/workMessageApproval',
    name: 'workMessageApproval',
    component: WorkMessageApproval
  },
  {
    path: '/workMessageReport',
    name: 'workMessageReport',
    component: WorkMessageReport
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
